var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.296,
    height: 21.181,
    viewBox: "0 0 29.296 21.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(-0.499 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M28.224,9a3.449,3.449,0,0,0-2.407-2.481C23.683,6,15.147,6,15.147,6s-8.536,0-10.67.571A3.449,3.449,0,0,0,2.071,9.052,35.98,35.98,0,0,0,1.5,15.615a35.98,35.98,0,0,0,.571,6.613A3.449,3.449,0,0,0,4.477,24.61c2.134.571,10.67.571,10.67.571s8.536,0,10.67-.571a3.449,3.449,0,0,0,2.407-2.481,35.98,35.98,0,0,0,.571-6.514A35.979,35.979,0,0,0,28.224,9Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M14.625,20.834l7.134-4.057L14.625,12.72Z",
    transform: "translate(-2.269 -1.162)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b29b6ea92a8a18bb68d828eaba1ddb6b.svg";
export { ForwardRef as ReactComponent };